module.exports = __webpack_public_path__ + "img/memoirerings@2x.a4d7d4d.jpg";